export default __webpack_public_path__ + "static/media/ISMO CLASS-3_SYLLABUS_2025-26.8415253e.pdf";